// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideThumbsUp as RawLucideThumbsUp } from "lucide-react";
export const LucideThumbsUp = /* @__PURE__ */ createIcon(RawLucideThumbsUp, "LucideThumbsUp", 2);
